import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Upload = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Upload" {...props}>
    <path d="M22 15.0004C22.5523 15.0004 23 15.4481 23 16.0004V18.0004C22.9998 20.7617 20.7613 23.0004 18 23.0004H6C3.23868 23.0004 1.00017 20.7617 1 18.0004V16.0004C1.00005 15.4481 1.44775 15.0004 2 15.0004C2.55225 15.0004 2.99995 15.4481 3 16.0004V18.0004C3.00017 19.6571 4.34325 21.0004 6 21.0004H18C19.6567 21.0004 20.9998 19.6571 21 18.0004V16.0004C21 15.4481 21.4477 15.0004 22 15.0004Z" fill="#000" /><path d="M11.3691 1.22499C11.7619 0.904635 12.3409 0.927229 12.707 1.29334L17.707 6.29334C18.0974 6.68388 18.0975 7.31694 17.707 7.70741C17.3165 8.09772 16.6835 8.09772 16.293 7.70741L13 4.41444V15.0004C12.9998 15.5525 12.5522 16.0004 12 16.0004C11.4478 16.0004 11.0002 15.5525 11 15.0004V4.41444L7.70703 7.70741C7.31655 8.09772 6.68345 8.09772 6.29297 7.70741C5.9025 7.31694 5.90261 6.68388 6.29297 6.29334L11.293 1.29334L11.3691 1.22499Z" fill="#000" />
  </StyledIcon>
));

Upload.displayName = 'Upload';

export { Upload };
